import { deburr } from 'lodash';
/**
 * (Taken from the adition api documentation)
 *
 * Proﬁle values must consist of the following characters:
 * Numbers: 0 - 9
 * Letters: a - z, A - Z
 * Special characters:
 * - underscore “_”
 * - hyphen “-“
 * - dot ”.”
 * - comma ”,”
 */
export const encodeProfileValue = profileValue => {
  if (profileValue == null || profileValue === '') {
    return '-1';
  }
  if (Array.isArray(profileValue)) {
    return profileValue.map(encodeProfileValue).join(',');
  }
  return deburr(profileValue).replace(/[^a-zA-Z0-9\-_.,]/g, '_');
};